module.exports = __webpack_public_path__ + "static/img/case2.4eb3416.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case2.png
// module id = Ljlw
// module chunks = 3